import Flex from '@creditflowresearch/uilib/Flex';
import IconStop from '@creditflowresearch/uilib/Icon/IconStop';
import styles from '../askAiChat.module.scss';

const StoppedNote = () => (
  <Flex align="center" gap={ 6 } className={ styles.stoppedNote } dataTest="askAiChatResponseStopped">
    <IconStop size={ 10 } />
    Response stopped
  </Flex>
);

export default StoppedNote;
